import * as Sentry from '@sentry/browser';

import fetchConfigSuccess from 'actions/configuration/fetchConfigSuccess';
import uiEvents from 'events/ui';

export default class ConfigurationGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleFetchConfigSuccess({ config, cohortId }) {
    let orgDomain = config.clusterUrl;
    let loginDomain = config.loginDomain;
    let providerId = this.getProviderId(config);
    let orgId = config.orgId;

    this.context.executeAction(uiEvents.initWidget({ orgDomain, loginDomain, appId: providerId, orgId }));
    this.context.executeAction(fetchConfigSuccess({ config, cohortId }));

    this.context.gateways.chatGateway.configureProvider(providerId);
  }

  getProviderId(config) {
    if (config.providerId) {
      return config.providerId;
    }

    // if providerID does not exist, fall back to appId (legacy configuration)
    return config.appId;
  }

  handleRefreshConfigSuccess({ config }) {
    this.context.executeAction(fetchConfigSuccess({ config }));
  }

  handleRefreshConfigError({ error }) {
    Sentry.captureMessage(`refresh configuration error: ${error}`);
  }
}
